/**
 * DIEUKYDIEU.TV - APPLE EMPTY STATE COMPONENT (js/components/empty-state.component.js)
 * Standardized Zero-Data & Search Empty State Presentation (< 120 lines).
 */

/**
 * Render chuỗi HTML cho Empty State
 * @param {Object} props - Cấu hình hiển thị
 * @returns {string} HTML string
 */
export function renderEmptyStateHTML(props = {}) {
    const {
        icon = 'folder_open',
        title = 'Chưa có nội dung',
        desc = '',
        actionText = '',
        actionOnClickAttr = '',
        className = '',
        compact = false
    } = props;

    const actionHtml = actionText ? `
        <button class="apple-empty-action-btn" type="button" ${actionOnClickAttr ? `onclick="${actionOnClickAttr}"` : ''}>
            <span>${actionText}</span>
        </button>
    ` : '';

    return `
        <div class="apple-empty-state ${compact ? 'compact' : ''} ${className}" role="status" aria-live="polite">
            <div class="apple-empty-icon-wrap" aria-hidden="true">
                <span class="material-symbols-rounded apple-empty-icon">${icon}</span>
            </div>
            <h3 class="apple-empty-title">${title}</h3>
            ${desc ? `<p class="apple-empty-desc">${desc}</p>` : ''}
            ${actionHtml}
        </div>
    `.trim();
}

/**
 * Tạo trực tiếp HTMLElement cho Empty State
 */
export function createEmptyStateElement(props = {}) {
    const temp = document.createElement('div');
    temp.innerHTML = renderEmptyStateHTML(props);
    const el = temp.firstElementChild;

    if (typeof props.onAction === 'function') {
        const btn = el.querySelector('.apple-empty-action-btn');
        if (btn) btn.addEventListener('click', props.onAction);
    }

    return el;
}
